import Button from "./Cards/Button";

interface BackButtonProps {
    link: string;
}
export default function BackButton({ link }: BackButtonProps) {
    return (
        <Button
            as="a"
            href={link}
            hasIcon={true}
            iconSrc="/Icons/arrowLeftBlack.svg"
            iconPlacement="left"
            text={"back"}
            backgroundColor=""
            border=""
            textColor="text-black"
            paddings=""
            alignment="justify-start"
        />
    );
}
